import addressApi from '@/api/pumba/addressApi';
import { API_URLS } from '@/api/pumba/urls';
import { Form } from '@/services/form';

const formAffiliateObject = {
    // Affiliate information
    legal_name: '',
    phone: '',
    document_number: '',
    registry_number: '',

    // Affiliate address
    street: '',
    number: '',
    neighborhood: '',
    complement: '',
    zipcode: '',
    city: '',
    state: '',
};

export const state = {
    formAffiliate: new Form(formAffiliateObject),
    sending: false,
    loading: false,
};

export const getters = {
    formAffiliate: (states) => states.formAffiliate,
    loading: (states) => states.loading,
};

export const mutations = {
    // Update form affiliate state
    ['UPDATE_FORM_AFFILIATE_VALUE'](states, { index, value }) {
        states.formAffiliate[index] = value;
    },

    ['RESET_FORM_AFFILIATE'](states) {
        states.formAffiliate.reset();
    },
};

export const actions = {
    async submit({ state: states, commit }, payload) {
        if (state.formAffiliate.legal_name) {
            commit('UPDATE_FORM_AFFILIATE_VALUE', { index: 'name', value: payload.name });
        }

        if (Object.values(state.formAffiliate).length) {
            await states.formAffiliate.post(API_URLS.ADDRESS.POST);
        }

        commit('RESET_FORM_AFFILIATE');
    },
    async loadZipcodeInfo({ commit }, zipcode) {
        zipcode = zipcode.replace('-', '');

        const payload = { params: { zipcode } };

        const { data: address } = await addressApi.fetchByZipcode(payload);

        commit('UPDATE_FORM_AFFILIATE_VALUE', { index: 'street', value: address.street });
        commit('UPDATE_FORM_AFFILIATE_VALUE', { index: 'neighborhood', value: address.neighborhood });
        commit('UPDATE_FORM_AFFILIATE_VALUE', { index: 'city', value: address.city });
        commit('UPDATE_FORM_AFFILIATE_VALUE', { index: 'state', value: address.uf });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
